import React, { useContext } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { DirectoryContext } from "../Directory.context";
import { CounterpartyDirectoryViewRow } from "../counterpartyDirectoryViewTypes";
import { CounterpartyCountCell } from "./CounterpartyCountCell";

export const CounterpartyJournalEntriesCell: React.FC<
    CellContext<ViewTableFeatures, CounterpartyDirectoryViewRow, number>
> = React.memo(({ row, table }) => {
    const { openGlDrawer } = useContext(DirectoryContext);
    const count = row.original.journalEntryLinesCount ?? 0;

    return (
        <CounterpartyCountCell
            count={count}
            isDisabled={count === 0}
            table={table}
            onClick={(e) => {
                e.stopPropagation();
                openGlDrawer(
                    row.original.counterparty?.id ?? null,
                    row.original.isNoCounterparty,
                    row.original.accountCode,
                );
            }}
        />
    );
});

CounterpartyJournalEntriesCell.displayName = "CounterpartyJournalEntriesCell";
